class Storage {
  constructor() {
    this.name = 'coolRideAdminUser';
    this.localStorage = window.localStorage;
  }

  setUser(user) {
    this.localStorage.setItem(this.name, JSON.stringify(user));
  }

  getUser() {
    const user = this.localStorage.getItem(this.name);
    try {
      return JSON.parse(user);
    } catch (e) {
      // A hand-edited value would throw on every read and blank every page,
      // /login included; treat it as signed out (ISSUE-0349).
      this.removeUser();
      return null;
    }
  }

  removeUser() {
    this.localStorage.removeItem(this.name);
  }

  getToken() {
    return this.getUser()?.token || '';
  }
}

const storage = new Storage();

export default storage;
